import { c as _c } from "react/compiler-runtime";
import { HeaderLayoutLeftButton } from "@components/page-layout/header/header-layout-left-button";
import { useCloseAccountSettings } from "@pages/account-settings/use-close-account-settings";
import { CloseIcon } from "@flat-ui";

/** Button in the header to close the account settings page */
export function CloseAccountSettingsButton() {
  const $ = _c(2);
  const {
    onCloseButtonClick
  } = useCloseAccountSettings();
  let t0;
  if ($[0] !== onCloseButtonClick) {
    t0 = <HeaderLayoutLeftButton tooltip="Close Account Settings" icon={CloseIcon} text="Close" onClickHandler={onCloseButtonClick} />;
    $[0] = onCloseButtonClick;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}